import React from 'react';

export default Object.freeze({
  RCS_TRANSFERABLE: 'RCS_TRANSFERABLE',
  AJIO_CASH_BONUS: 'AJIO_CASH_BONUS',
  RCS_NONTRANSFERABLE: 'RCS_NONTRANSFERABLE',
  AW_STATUS_ACTIVE: 'ACTIVE',
  AW_STATUS_EXPIRED: 'EXPIRED',
  AW_STATUS_PENDING: 'PENDING',
  AW_RUPEE_SYMBOL: <span>&#8377;</span>,
  AW_BONUS_USE_STATUS_SPEND: 'SPEND',
  AW_BONUS_USE_STATUS_REFUND: 'REFUND',
  AW_BONUS_USE_STATUS_EXPIRY: 'EXPIRY',
  AW_BONUS_USE_STATUS_ACTIVATION: 'ACTIVATION'
});
